import { random } from "./helpers"

const NETWORK_FACTS = [
    "The first 'internet' was called ARPANET, created in 1969, and the first message ever sent over it was 'LO'? They tried to send 'LOGIN,' but the system crashed after the first two letters!",

    "IPv6, the new version of internet protocol, can support 340 undecillion (that's 340 followed by 36 zeros) unique IP addresses—enough for every device on Earth to have its own?",

    "Packets of data traveling across the internet don't always take the same path? They can take entirely different routes to reach the same destination, depending on network traffic.",

    "A 'data packet' is often smaller than an email or image, meaning that large files are broken into thousands of packets, which are then reassembled at their destination?",

    "Ethernet, a technology we still use today, was first invented in the 1970s and named after the 'luminiferous ether,' a theoretical invisible medium once believed to carry light waves?",

    "'ping' is a term borrowed from sonar technology? Just like submarines use sonar pings to locate objects, computers send network pings to check if another device is reachable.",

    "Traceroute is a tool that shows you all the 'hops' or stops your data takes across routers and networks before reaching its destination? It's like following your data on a road trip.",

    "MAC addresses (Media Access Control) are unique to each device's network interface, sort of like a fingerprint for your device's network hardware?",

    "Packets that get lost or delayed in transit are automatically resent until the complete data arrives correctly, which is why you rarely notice small network issues?",

    "Cables labeled as 'Cat' followed by a number (like Cat5 or Cat6) stand for 'Category,' and the higher the number, the faster and more efficient the cable is for network traffic?",

    "The term 'latency' in networks refers to the time it takes for data to travel from one point to another? Lower latency means faster response times.",

    "Most modern internet connections are full-duplex, meaning data can be sent and received at the same time, unlike the older half-duplex connections where only one can happen at a time?",

    "When you 'Google' something, it triggers dozens of small queries to various servers around the world, retrieving your results in less than a second?",

    "Cables longer than 100 meters can degrade the quality of a network signal? That's why long-distance networks often use fiber optic cables to avoid this issue.",

    "The 'TTL' (Time to Live) field in a data packet limits how many hops a packet can take before being discarded? It prevents packets from endlessly bouncing around the network.",

    "Data sent over a network can pass through multiple countries, and sometimes even under the ocean, before reaching its destination?",

    "Some networks use 'jumbo frames,' which are larger-than-normal packets, to increase efficiency and reduce overhead in environments like data centers?",

    "The internet is mostly dependent on undersea cables? There are over 1.3 million kilometers (about 800,000 miles) of fiber optic cables lying under the world's oceans, carrying most of the global internet traffic.",

    "Subnet masks are used to divide IP addresses into network and host portions, allowing networks to be more organized and scalable?",

    "VLANs (Virtual LANs) can be used to separate and organize devices on a network, even if they're connected to the same physical switch, improving security and management?",

    "The 'loopback' IP address, 127.0.0.1, is used to test network interfaces on your own machine, without sending any data out onto the actual network?",

    "TCP/IP, the basic communication language of the internet, was first tested between two computers in 1983, marking the official start of the modern internet?",

    "CSMA/CD (Carrier Sense Multiple Access with Collision Detection) was the original method Ethernet used to detect and handle collisions on a network? It's now mostly obsolete due to modern switching technology.",

    "DNS 'spoofing' is a trick where attackers send false DNS information to redirect traffic to malicious websites without the user knowing?",

    "Fiber optic cables can transmit data at nearly the speed of light, making them much faster than copper cables, which use electrical signals?",

    "DHCP (Dynamic Host Configuration Protocol) automatically assigns IP addresses to devices on a network, so you don't have to configure them manually?",

    "MTU (Maximum Transmission Unit) defines the largest packet size that can be sent in a single transmission? Larger MTUs reduce overhead, but if they're too big, they can cause fragmentation.",

    "IPv4 addresses are 32-bit numbers, allowing for about 4.3 billion unique addresses? Due to address exhaustion, IPv6 was introduced, offering 128-bit addresses—enough for every grain of sand on Earth!",

    "Broadcast storms happen when too many broadcast messages are sent out on a network, overwhelming it and causing slowdowns or crashes?",

    "Proxy servers act as intermediaries between your device and the internet, improving security and sometimes even speeding up network traffic by caching frequently requested content?",
]

/**
 * Gets a reandom network fact
 * @returns {string} a network fact
 */
export const getRandomNetworkFact = () : string => {
    return NETWORK_FACTS[random(0, NETWORK_FACTS.length-1)]
}